var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMicrophoneOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .micoff_a {\n                fill: none !important;\n            }\n\n            .micoff_b {\n                fill: #fff;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5576.5 5474.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "micoff_a",
    width: 32,
    height: 32,
    transform: "translate(-5576.5 -5474.5)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "micoff_b",
    d: "M12.879,5.673a1.52,1.52,0,1,1,3.04,0l-.013,4.952L18.2,12.892V5.8a3.787,3.787,0,0,0-7.548-.443l2.229,2.229ZM23.264,13.4H21.111a6.551,6.551,0,0,1-.342,2.077l1.608,1.608A8.238,8.238,0,0,0,23.264,13.4ZM4.786,3.089,3,4.875l7.6,7.6V13.4a3.794,3.794,0,0,0,3.8,3.8,3.489,3.489,0,0,0,.823-.1l2.1,2.1a6.964,6.964,0,0,1-2.926.659A6.572,6.572,0,0,1,7.686,13.4H5.533a8.845,8.845,0,0,0,7.6,8.511v4.154h2.533V21.91a9.029,9.029,0,0,0,3.23-1.14l5.319,5.319L26,24.3Z",
    transform: "translate(2 2)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicrophoneOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_microphone_off.cccafbecc2122692cd39b1a2c51c00a0.svg";